// External Dependencies:
import React from 'react'
import lozad from 'lozad'

class Sponsors extends React.Component {
	constructor() {
		super()

		this.observer = lozad( '.lozad', {
			load: ( el ) => {
				el.src = el.dataset.src
				el.onload = () => {
					el.classList.add( 'lozad-loaded' )
				}
			}
		})
	}

	componentDidMount() {
		this.observer.observe()
	}

	render() {
		const { network, sponsorsPage } = this.props
		let data

		if ( network ) {
			data = safeSiteData.sponsors_network
		} else if ( sponsorsPage ) {
			data = safeSiteData.sponsors_page
		} else {
			data = safeSiteData.sponsors_local
		}

		const heading = network ? 'Our Network Partners' : 'Our Supporters'

		var sponsors = null
		var sponsorsItems = ''

		if ( data && data.length ) {
			sponsorsItems = data.map( ( e, i ) => {
				let content

				if ( sponsorsPage && e.content ) {
					content = <div className="-content" dangerouslySetInnerHTML={ { __html: e.content } } />
				}

				if ( e.url ) {
					return (
						<a className="-sponsor" href={ e.url } key={ i }>
							<div className="-image">
								<img className="lozad" data-src={ e.image_url } alt="" />
							</div>

							{ content }
						</a>
					)
				} else {
					return (
						<div className="-sponsor -no-link" key={ i }>
							<div className="-image">
								<img className="lozad" data-src={ e.image_url } alt="" />
							</div>

							{ content }
						</div>
					)
				}
			})
		}

		if ( ! sponsorsItems ) {
			return null
		}

		if ( sponsorsPage ) {
			sponsors = (
				<div className="sponsors-page">
					<div className="-inner">
						<div className="-sponsors">
							{ sponsorsItems }
						</div>
					</div>
				</div>
			)
		} else {
			sponsors = (
				<div className="wide-section-sponsors wide-section">
					<div className="-inner">
						<h3>{ heading }</h3>

						<div className="-sponsors">
							{ sponsorsItems }
						</div>
					</div>
				</div>
			)
		}

		return sponsors
	}
}

export default Sponsors



// WEBPACK FOOTER //
// ./components/sponsors/sponsors.jsx